import { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    checkEnvironmentIsTao,
    generateTitle,
} from 'constants/GlobalConfig';
import * as Actions from 'flex/Actions';
import Title from 'components/modules/Title';

import { AuthenticatorModal } from '../pages/MFA/AuthenticatorModal';

const { Content, Sider } = Layout;
const MENU_WIDTH_DEFAULT = 250;
const MENU_WIDTH_RESPONSIVE = 210;
const IPAD_BREAKPOINTS = 1024;

/**
 * 認証系ページ用レイアウト
 * BaseLayout と同じ構造だが、サイドバーにはロゴのみを表示し、
 * ヘッダー・フッター・ナビゲーションメニューは表示しない
 */
const AuthLayout = props => {
    const location = useLocation();
    const [titleObject, setTitleObject] = useState(generateTitle(location.pathname));
    const [collapsed, setCollapsed] = useState(false);
    const [menuWidth, setMenuWidth] = useState(MENU_WIDTH_DEFAULT);
    const dispatch = useDispatch();

    useEffect(() => {
        setTitleObject(generateTitle(location.pathname));
        // ブラウザウィンドウのサイズと最大タッチポイント数の確認
        // このロジックは、PCデバイスとタッチスクリーンデバイス（タブレット/モバイル）を区別するために使用されます。
        if (window.innerWidth > IPAD_BREAKPOINTS && navigator.maxTouchPoints === 0) {
            document.querySelector('html').scrollTo(0, 0);
        } else {
            document.querySelector('html').scrollTo(5, 5);
        }
    }, [location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            // iOS 26でサイドバーのバグを回避するために、120ミリ秒スリープする。
            setTimeout(() => {
                if (window.innerWidth <= IPAD_BREAKPOINTS) {
                    setMenuWidth(MENU_WIDTH_RESPONSIVE);
                    setCollapsed(true);
                } else {
                    setMenuWidth(MENU_WIDTH_DEFAULT);
                    setCollapsed(false);
                }
            }, 120);
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        dispatch(Actions.http.connection.authentication.setup());
    }, []);


    const logout = () => {
        dispatch(Actions.http.connection.authentication.logout());
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Title text={titleObject.title} />
            <Sider
                style={{
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                }}
                collapsedWidth='0'
                collapsed={collapsed}
                collapsible={window.innerWidth <= IPAD_BREAKPOINTS}
                onCollapse={() => {
                    setCollapsed(!collapsed);
                }}
                className='global-nav'
                width={menuWidth}
            >
                {/* ロゴのみ表示 — ナビゲーションメニューは非表示 */}
                <div
                    className={checkEnvironmentIsTao() ? 'logo-m' : 'logo'}
                    style={{ backgroundSize: 'contain' }}
                />
            </Sider>
            <Layout className='container-outer'>
                <Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                    {props.children}
                </Content>
            </Layout>

            <AuthenticatorModal isVerifyMode logout={logout}/>
        </Layout>
    );
};

export default AuthLayout;
